/**
 * Given a ref to a parent element and child element this function will scroll
 * the parent element to make the child element visible.
 */
export const scrollParentToChild = (parent: HTMLElement, child: HTMLElement): void => {
  const parentRect = parent.getBoundingClientRect()
  const childRect = child.getBoundingClientRect()

  const isVisible = isChildVisible(parentRect, childRect)

  if (!isVisible) {
    const scrollTop = childRect.top - parentRect.top
    const scrollBottom = childRect.bottom - parentRect.bottom
    // middleModifier compensates to center child in the parent
    const middleModifier = Math.floor((parentRect.height - childRect.height) / 2)

    if (Math.abs(scrollTop) < Math.abs(scrollBottom)) {
      // we're above the top of the parent
      parent.scrollBy({ top: scrollTop - middleModifier, left: 0, behavior: 'smooth' })
    } else {
      // we're bellow the bottom of parent
      parent.scrollBy({ top: scrollBottom + middleModifier, left: 0, behavior: 'smooth' })
    }
  }
}

function isChildVisible(parentRect: DOMRect, childRect: DOMRect): boolean {
  if (childRect.top >= parentRect.bottom || childRect.bottom <= parentRect.top) {
    return false
  }
  return true
}
